import gql from "graphql-tag";

export default gql`
  query getOrderRating($orderId: ID!) {
    getOrderRating(orderId: $orderId) {
      partnerId
      orderId
      consumerId
      rating
      comments
      createdAt
      updatedAt
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Query/GetOrderRating.js